/* eslint-disable react/prop-types */
import React from 'react';
import { withTranslation } from 'react-i18next';

// @material-ui/core components
import Button from '@material-ui/core/Button/Button';
// our components
import { FatalError } from 'helpers/errors';
import RouterContext from 'helpers/routerContext';

/**
 * @class
 * @extends React.Component
 */
class GraphqlViewErrorBoundary extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  /**
   * @description
   * Handle click when click button retry.
   */
  handleClick = () => {
    const history = this.context;
    history.go(0);
  };

  /**
   * @description
   * React lifecycle method to update state when catch errors.
   *
   * @param {Object} error - Error.
   * @param {Object} errorInfo - Error info.
   */
  // eslint-disable-next-line no-unused-vars
  componentDidCatch(error, errorInfo) {
    // Update state so the next render will show the fallback UI.
    if (error instanceof FatalError) {
      throw error;
    } else {
      this.setState({ hasError: true });
    }
  }

  /**
   * @description
   * Render errors.
   *
   * @returns {*} Errors.
   */
  render() {
    const { hasError } = this.state;
    const { children, t } = this.props;
    if (hasError) {
      return (
        <React.Fragment>
          <div style={{ textAlign: 'center' }}>
            <p>{t('errors.view')}</p>
            <Button color="primary" onClick={this.handleClick}>
              {t('common.retry')}{' '}
            </Button>
          </div>
        </React.Fragment>
      );
    }
    return children;
  }
}

export default withTranslation()(GraphqlViewErrorBoundary);
